import Button from "@imminently/decisively-ui/Button";
import Card from "@imminently/decisively-ui/Card";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import type React from "react";
import type { GraphExpandDirection, OrgModelEntityNodeData } from "../types";

export const OrgModelGraphEntityNode = (props: NodeProps) => {
  const data = props.data as OrgModelEntityNodeData;

  const stopAndExpand = (event: React.MouseEvent, direction: GraphExpandDirection) => {
    event.preventDefault();
    event.stopPropagation();
    if (direction === "outgoing") data.onExpandOutgoing(data.entityType, data.entityId);
    else data.onExpandIncoming(data.entityType, data.entityId);
  };

  return (
    <Card
      elevation="sm"
      className="min-h-30 w-70 gap-2 p-3"
    >
      <dl>
        <dt className="text-xs uppercase tracking-wider text-muted-foreground">{data.entityType}</dt>
        <dd className="truncate font-mono text-xl font-semibold text-foreground">{data.entityLabel}</dd>
      </dl>
      <div className="mt-auto flex gap-2">
        <Button
          size="sm"
          variant="outline"
          intent="secondary"
          className="min-w-0 flex-1"
          label={data.expandingOutgoing ? "Loading pointed-by records" : "Pointed By"}
          disabled={data.expandingOutgoing}
          onClick={(event) => stopAndExpand(event, "outgoing")}
        >
          {data.expandingOutgoing ? "Loading..." : "Pointed By"}
        </Button>
        <Button
          size="sm"
          variant="outline"
          intent="secondary"
          className="min-w-0 flex-1"
          label={data.expandingIncoming ? "Loading points-to records" : "Points To"}
          disabled={data.expandingIncoming}
          onClick={(event) => stopAndExpand(event, "incoming")}
        >
          {data.expandingIncoming ? "Loading..." : "Points To"}
        </Button>
      </div>
      <Handle
        type="target"
        position={Position.Right}
      />
      <Handle
        type="source"
        position={Position.Left}
      />
    </Card>
  );
};

export default OrgModelGraphEntityNode;
